export default __webpack_public_path__ + "static/black-5efb86fecc67fd1e9b27ab76f112baad.jpg";